<template lang="pug">
    .celebration-info
      .info_basic_title
        .title-left
          span {{ $t(`${BASE_TRANSLATION_PATH}.title`) }}
          aiq-tooltip(effect="dark"
                :show-after="1000"
                :content="$t(`${BASE_TRANSLATION_PATH}.tooltip.title`)")
            fa-icon.question-mark(:icon="['fas', 'circle-question']")
        aiq-tooltip(effect="dark"
              placement="top"
              :show-after="1000"
              :content="$t(`${BASE_TRANSLATION_PATH}.tooltip.add_button`)")
          i.el-icon-plus.add-celebration-button(@click="openAddCelebrationForm")

      .celebration-info-add(v-show="showAddFormFlag")
        .celebration-info__language(v-if="availableLanguages.length > 1")
          aiq-select.lang_select(v-model="selectedLanguage"
                :placeholder="$t(`${BASE_TRANSLATION_PATH}.select_language`)"
                size="small"
                :suffix-icon="Icon.CaretBottom"
                :clear-icon="Icon.Close"
                :disabled="isBusy"
                clearable)
            aiq-option(v-for="item in availableLanguages", :key="item.code", :label="item.name", :value="item.code")
        .celebration-info__type
          aiq-select(v-model="newCelebration.type"
                :placeholder="$t(`${BASE_TRANSLATION_PATH}.placeholder`)"
                size="small"
                :suffix-icon="Icon.CaretBottom"
                :clear-icon="Icon.Close"
                :disabled="isBusy"
                clearable)
            aiq-option(v-for="item in celebrationTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value")
        .celebration-info__date
          aiq-date-picker(v-model="newCelebration.date"
                type="date"
                size="small"
                placeholder="Select date"
                format="MM/DD"
                align="right"
                :clear-icon="Icon.Close"
                :style="{ width: '100%' }"
                :disabled="isBusy"
                clearable)
        .celecetion-info__button
          span.spinner
            font-awesome-icon(v-if="isBusy"
                  size="lg"
                  icon="spinner"
                  spin)
          aiq-button.submit-celebration(type="primary"
                size="small"
                :disabled="!canSubmit || isBusy"
                @click="submitCelebration") {{ $t('global.add') }}

    .celebration-info__list
      .celebration-info__list-item(v-for="item in customerCelebrationInfo"
            :key="item.type"
            :class="{ 'is-disabled': isDisabledCelebration(item) }")
        aiq-tooltip(v-if="isDisabledCelebration(item)"
              effect="dark"
              :show-after="1000"
              :content="$t(`${BASE_TRANSLATION_PATH}.tooltip.disabled_item`) + ` ${item.date}`")
          div {{ !item.type ? "" : item.type.charAt(0).toUpperCase() + item.type.slice(1) }} {{ item.date? ` (${item.date})` : '' }}
        div(v-else) {{ !item.type ? "" : item.type.charAt(0).toUpperCase() + item.type.slice(1) }} {{ item.date? ` (${item.date})` : '' }}

        aiq-tooltip(effect="dark"
              placement="top"
              :show-after="1000"
              :content="$t(`${BASE_TRANSLATION_PATH}.delete`)")
          span.delete-item(v-if="!isDisabledCelebration(item)" @click="removeCelebration(item)")
            i.el-icon-delete
</template>

<script>
import get from 'lodash/get';
import dayjs from '@/localPlugins/dayjs';
import set from 'lodash/set';
import findIndex from 'lodash/findIndex';
import { mapState } from 'vuex';
import { AVAILABLE_LANGUAGES, DEFAULT_SYSTEM_LANGUAGE } from '@/constants/settings';

export default {
  name: 'CelebrationInfo',

  data() {
    return {
      BASE_TRANSLATION_PATH: 'conversation_tab.side_panel.customer_info_accordion.section.celebration_info',
      newCelebration: {
        type: null,
        date: null,
      },
      availableLanguages: [],
      selectedLanguage: null,
      celebration_key: null,
      list: {},
      showAddFormFlag: false,
      celebrationTypes: [],
      isBusy: false,
    };
  },
  props: {
    celebrationSettings: {
      type: Object,
      default: () => ({}),
    },
  },
  async mounted() {
    const webchatLangSettings = await this.$store.dispatch('configs/getWebchatLanguageSettings');
    const enabledLangs = webchatLangSettings.enabled_languages || [];
    this.availableLanguages = AVAILABLE_LANGUAGES.filter(lang => enabledLangs.includes(lang.code));

    if (this.availableLanguages.length === 1) {
      this.selectedLanguage = this.availableLanguages[0].code;
    }
    else if (this.availableLanguages.length > 1) {
      if (this.availableLanguages.find(lang => lang.code === DEFAULT_SYSTEM_LANGUAGE.code)) {
        this.selectedLanguage = DEFAULT_SYSTEM_LANGUAGE.code;
      }
      else {
        this.selectedLanguage = this.availableLanguages[0].code;
      }
    }

    this.updateCelebrationKey(this.selectedLanguage);
    this.updateCelebrationTypes(this.celebrationSettings);
  },
  watch: {
    celebrationSettings(newValue) {
      this.updateCelebrationTypes(newValue);
    },
    selectedLanguage(newValue) {
      this.updateCelebrationKey(newValue);
      this.updateCelebrationTypes(this.celebrationSettings);
      this.newCelebration.type = null;
    },

    customer(newVal, oldVal) {
      if (newVal && newVal.id !== oldVal?.id) {
        this.showAddFormFlag = false;
      }
    },
  },

  computed: {
    customerCelebrationInfo() {
      //filter out celebration that are not in the list
      const celebrationList = this.celebrationSettings;
      const customerCelebration = get(this.customer, 'metadata.celebration', []);
      return customerCelebration.filter((item) => {
        return celebrationList[this.celebration_key]?.some((celebration) => {
          return celebration.type === item.type;
        });
      });
    },
    canSubmit() {
      return this.newCelebration.type;
    },
    ...mapState({
      customer: state => state.conversations.selectedCustomer,
    }),
  },

  methods: {

    updateCelebrationTypes(celebrationSettings) {
      if (celebrationSettings[this.celebration_key]) {
        this.celebrationTypes = celebrationSettings[this.celebration_key].map((item) => {
          return {
            value: item.type,
            label: item.type,
          };
        });
      }
      else {
        this.celebrationTypes = [];
      }
    },

    updateCelebrationKey(langCode) {
      if (!langCode || langCode === 'en') {
        this.celebration_key = 'celebration';
      }
      else {
        this.celebration_key = `celebration_${langCode}`;
      }
    },

    deleteConfirm() {

      return new Promise(resolve => {
        this.$aiq.confirm(
          this.$t(`${this.BASE_TRANSLATION_PATH}.delete_confirm.title`),
          this.$t(`${this.BASE_TRANSLATION_PATH}.delete_confirm.message`),
          {
            cancelButtonText: this.$t(`${this.BASE_TRANSLATION_PATH}.delete_confirm.cancel_button`),
            confirmButtonText: this.$t(`${this.BASE_TRANSLATION_PATH}.delete_confirm.confirm_button`),
          },
        )
          .then(() => resolve(true), () => resolve(false));
      });
    },

    async removeCelebration(item) {

      const response = await this.deleteConfirm();
      if (response) {
        const celebration = get(this.customer, 'metadata.celebration', []);
        const index = findIndex(celebration, item);
        celebration.splice(index, 1);
        set(this.customer, 'metadata.celebration', celebration);

        await this.updateCustomer(this.customer, 'remove');
      }
    },

    isDisabledCelebration(item) {
      return get(item, 'disable', false);
    },

    async submitCelebration() {
      this.isBusy = true;

      const celebration = get(this.customer, 'metadata.celebration', []);
      const date = this.newCelebration.date;
      const formattedDate = date ? dayjs(date).format('MM/DD') : null;

      const newCelebration = {
        type: this.newCelebration.type,
        date: formattedDate,
      };
      //check if the celebration already exists
      const existingCelebration = celebration.find((item) => item.type === newCelebration.type && item.date === newCelebration.date);
      if (existingCelebration) {
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.duplicate`));
        return;
      }
      celebration.push(newCelebration);
      set(this.customer, 'metadata.celebration', celebration);

      await this.updateCustomer(this.customer);

      this.showAddFormFlag = false;
      this.isBusy = false;
    },

    async updateCustomer(customer, action = 'add') {
      try {
        await this.$store.dispatch('conversations/updateCustomer', [
          customer.id,
          {
            ...customer,
          },
        ]);

        if (action === 'add') {
          this.$aiq.notify.success(this.$t(`${this.BASE_TRANSLATION_PATH}.success_add`));
          this.newCelebration = {
            type: null,
            date: null,
          };
        }
        else if (action === 'remove') {
          this.$aiq.notify.success(this.$t(`${this.BASE_TRANSLATION_PATH}.success_delete`));
        }
      } catch (error) {
        this.$aiq.notify.error(this.$t(`${this.BASE_TRANSLATION_PATH}.failure`));
      }
    },

    openAddCelebrationForm() {
      this.showAddFormFlag = true;
    },

  },
};
</script>

<style lang="scss" scoped>

.spinner {
  margin-right: 10px;
}

.customer-info-basic_title {
  color: #48576A;
  font-size: 15px;
  line-height: 12px;
  font-weight: 300;
}

.celebration-info {
  .el-icon-plus {
    cursor: pointer;
  }
}

.celebration-info-add {
  margin-top: 10px;
}

.celebration-info__date {
  position: relative;
  padding-top: 10px;
  :deep(.el-input) {
    .el-input__prefix .el-input__icon {
      left: 0;
      right: auto;
      svg {
        width: 1.5em;
        height: 1.5em;
        color: #A8A9AB;
      }
    }
    .el-input__suffix .el-input__icon {
      svg {
        width: 16px;
        height: 16px;
        color: #BFCBD9;
      }
    }
    input {
      border: 1px solid #bfcbd9;
      padding-left: 35px;
      &:focus {
        outline: none;
        border-color: #409eff;
      }
      &::placeholder {
        font-size: 12px;
      }
    }
  }
}

.celebration-info__type,
.celebration-info__language {
  :deep(.el-select .el-select__suffix .el-input__icon svg) {
    width: 1.5em;
    height: 1.5em;
    color: #A8A9AB;
    margin-top: 3px;
  }
}

.celebration-info__type {
  margin-top: 10px;
}

.celecetion-info__button {
  margin-top: 10px;
  text-align: right;
  .submit-celebration {
    background: #194696;
    font-size: 14px;
    border: none;
    &:hover {
      background: #2677FF;
    }
    &.is-disabled, &.is-disabled:hover, &.is-disabled:focus {
      background: #8ca2ca;
    }
  }
}

.celebration-info__list {
  margin: 10px 0;

  .celebration-info__list-item {
    color: #FFF;
    font-size: 12px;
    background: #414246;
    padding: 5px 15px;
    margin-bottom: 10px;
    border-radius: 2px;
    position: relative;

    &.is-disabled {
      background: #CBCBCB;
      color: #6B6D70;
    }

    .delete-item {
      position: absolute;
      display: block;
      cursor: pointer;
      color: #28292c;
      background: #eaebed;
      border: 1px solid #a8a9ab;
      border-radius: 2px;
      right: -2px;
      top: -14px;
      padding: 3px;
      font-size: 18px;
      line-height: 18px;
      transition: opacity 0.3s ease, visibility 0.3s ease;
      visibility: hidden;
      opacity: 0;

      &:hover {
        color: #194696;
      }
    }

    &:hover {
      .delete-item {
        opacity: 1;
        visibility: visible;
      }
    }
  }

}

.info_basic_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .title-left {
    font-size: 14px;
    font-weight: 600;
    font-family: 'Roboto';
    display: flex;
    align-items: center;
    gap: 6px;
  }
}

:deep(.el-date-editor.el-input) {
  height: 30px;
}

:deep(.el-select__wrapper) {
  min-height: 30px;
  height: 30px;
  font-size: 12px;
}

</style>